import React, { Component } from "react";
import PropTypes from "prop-types";
import TevekenysegContent from "./TevekenysegContent";
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../WeboldalakTooltips';

class TevekenysegBase extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {"Tevékenységek"}
              <CustomTooltip text={getTooltip('tevekenysegek')} id="tevekenysegekTT" />
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <TevekenysegContent {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TevekenysegBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default TevekenysegBase;
